import { render, staticRenderFns } from "./chip.vue?vue&type=template&id=2404a1c5&scoped=true"
import script from "./chip.vue?vue&type=script&lang=js"
export * from "./chip.vue?vue&type=script&lang=js"
import style0 from "./chip.vue?vue&type=style&index=0&id=2404a1c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2404a1c5",
  null
  
)

export default component.exports